import React from 'react';
import ActionDialog from '../../globalModals/ActionDialog';
import AIAssistantForm from './AIAssistantForm';
import { GlobalDialogProps } from '../../../types';

interface AIAssistantDialogProps extends GlobalDialogProps {
  formSource?: string;
}

const AIAssistantDialog: React.FC<AIAssistantDialogProps> = ({
  onClose,
  formSource = 'AI Assistant Dialog',
}) => {
  return (
    <ActionDialog
      title=""
      open
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      actions={[]}
      sx={{
        '& .MuiDialog-paper': {
          height: '100vh',
          maxWidth: '80vw',
          width: '60%',
          paddingX: '10px',
          padding: '0 !important',
          bgcolor: (theme) =>
            theme.palette.mode === 'dark' ? '#0a0a0a' : '#fafafa',
        },
        '& .MuiDialogTitle-root': {
          display: 'none',
        },
        '& .MuiDialogContent-root': {
          padding: '0 !important',
          margin: '0 !important',
        },
        '& .MuiDialogActions-root': {
          display: 'none',
        },
      }}
    >
      <AIAssistantForm formSource={formSource} onClose={onClose} />
    </ActionDialog>
  );
};

export default AIAssistantDialog;
